module.exports = __webpack_public_path__ + "core-fonts/maxpro_s-demibold-webfont.8a217ab5fa7044266d4af81ad976b326.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/font/maxpro_s-demibold-webfont.ttf
// module id = 16
// module chunks = 0